var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 21.25C14.7167 21.25 10.4167 16.95 10.4167 11.6667C10.4167 6.38337 14.7167 2.08337 20.0001 2.08337C25.2834 2.08337 29.5834 6.38337 29.5834 11.6667C29.5834 16.95 25.2834 21.25 20.0001 21.25ZM20.0001 4.58337C16.1001 4.58337 12.9167 7.76671 12.9167 11.6667C12.9167 15.5667 16.1001 18.75 20.0001 18.75C23.9001 18.75 27.0834 15.5667 27.0834 11.6667C27.0834 7.76671 23.9001 4.58337 20.0001 4.58337Z",
    fill: "url(#paint0_linear_382_7634)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3668 37.9166C25.7335 37.9166 25.1335 37.6832 24.7002 37.2499C24.1835 36.7332 23.9502 35.9833 24.0668 35.1999L24.3835 32.95C24.4668 32.3667 24.8169 31.6833 25.2335 31.25L31.1335 25.35C33.5002 22.9833 35.5835 24.3333 36.6002 25.35C37.4669 26.2167 37.9168 27.1499 37.9168 28.0833C37.9168 29.0332 37.4835 29.9166 36.6002 30.7999L30.7001 36.7C30.2835 37.1167 29.5835 37.4667 29.0002 37.55L26.7501 37.8666C26.6168 37.8999 26.5002 37.9166 26.3668 37.9166ZM33.8502 26.5333C33.5502 26.5333 33.2835 26.7333 32.9001 27.1167L27.0002 33.0166C26.9502 33.0666 26.8668 33.2333 26.8668 33.2999L26.5668 35.3833L28.6502 35.0833C28.7168 35.0666 28.8835 34.9833 28.9335 34.9333L34.8335 29.0333C35.1002 28.7666 35.4168 28.3833 35.4168 28.0833C35.4168 27.8333 35.2169 27.4833 34.8335 27.1167C34.4335 26.7167 34.1335 26.5333 33.8502 26.5333Z",
    fill: "url(#paint1_linear_382_7634)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8669 32.0333C34.7502 32.0333 34.6336 32.0167 34.5336 31.9834C32.3336 31.3667 30.5836 29.6167 29.9669 27.4167C29.7836 26.7501 30.1669 26.0667 30.8336 25.8834C31.5003 25.7001 32.1836 26.0833 32.3669 26.75C32.7502 28.1167 33.8336 29.2 35.2003 29.5834C35.8669 29.7667 36.2503 30.4667 36.067 31.1167C35.917 31.6667 35.4169 32.0333 34.8669 32.0333Z",
    fill: "url(#paint2_linear_382_7634)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68359 37.9167C5.00026 37.9167 4.43359 37.35 4.43359 36.6667C4.43359 29.55 11.417 23.75 20.0003 23.75C21.817 23.75 23.617 24.0167 25.3003 24.5167C25.967 24.7167 26.3336 25.4167 26.1336 26.0667C25.9336 26.7334 25.2336 27.1 24.5836 26.9C23.117 26.4667 21.5836 26.2333 20.0003 26.2333C12.8003 26.2333 6.93359 30.9 6.93359 36.65C6.93359 37.35 6.36693 37.9167 5.68359 37.9167Z",
    fill: "url(#paint3_linear_382_7634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_382_7634",
    x1: 10.4167,
    y1: 10.754,
    x2: 29.5834,
    y2: 10.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_382_7634",
    x1: 24.0374,
    y1: 30.3143,
    x2: 37.9168,
    y2: 30.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_382_7634",
    x1: 29.9211,
    y1: 28.6404,
    x2: 36.1127,
    y2: 28.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_382_7634",
    x1: 4.43359,
    y1: 30.1587,
    x2: 26.1881,
    y2: 30.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.195a98fe09062b5ccf9f3357dbbd52c4.svg";
export { ForwardRef as ReactComponent };